import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import Loading from '.';
import isBrowser from '../../features/helpers/is-browser';
import { useTranslations } from '../../features/providers/translations-provider';
import Button from '../common/button';
import Div from '../common/div';
import Typography from '../common/typography';
const LoadingScreen = ({ timeoutMs, onTimeoutAction, timeoutTitle, timeoutDescription, timeoutActionLabel, }) => {
    const theme = useTheme();
    const { t } = useTranslations();
    const [hasTimedOut, setHasTimedOut] = useState(false);
    useEffect(() => {
        setHasTimedOut(false);
        if (!timeoutMs)
            return;
        const timeoutId = setTimeout(() => {
            setHasTimedOut(true);
        }, timeoutMs);
        return () => clearTimeout(timeoutId);
    }, [timeoutMs]);
    const handleTimeoutAction = () => {
        if (onTimeoutAction) {
            onTimeoutAction();
            return;
        }
        if (isBrowser) {
            window.location.reload();
        }
    };
    return (_jsx("div", { style: {
            width: '100vw',
            height: '100vh',
            background: theme.colors.background,
        }, children: hasTimedOut ? (_jsxs(Div, { flex: "column", justify: "center", align: "center", gap: theme.spacing.lg, style: {
                height: '100%',
                maxWidth: 560,
                margin: '0 auto',
                padding: theme.spacing.xl,
                textAlign: 'center',
            }, children: [_jsxs(Div, { flex: "column", gap: theme.spacing.md, children: [_jsx(Typography.Title, { level: 4, textAlign: "center", children: timeoutTitle !== null && timeoutTitle !== void 0 ? timeoutTitle : t('common|loadingTimeoutTitle') }), _jsx(Typography, { textAlign: "center", children: timeoutDescription !== null && timeoutDescription !== void 0 ? timeoutDescription : t('common|loadingTimeoutDescription') })] }), _jsx(Button, { fitContent: true, variant: "main-action", onClick: handleTimeoutAction, children: timeoutActionLabel !== null && timeoutActionLabel !== void 0 ? timeoutActionLabel : t('common|refresh') })] })) : (_jsx(Loading, { size: "extra-large" })) }));
};
export default LoadingScreen;
